/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../model';
// @ts-ignore
import { GetTreatmentsdatabaseResponse } from '../model';
// @ts-ignore
import { PostTreatmentDatabaseRequest } from '../model';
// @ts-ignore
import { PutTreatmentDatabaseRequest } from '../model';
/**
 * TreatmentDatabasesApi - axios parameter creator
 * @export
 */
export const TreatmentDatabasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostTreatmentDatabaseRequest} postTreatmentDatabaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTreatmentDatabase: async (postTreatmentDatabaseRequest: PostTreatmentDatabaseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTreatmentDatabaseRequest' is not null or undefined
            assertParamExists('addTreatmentDatabase', 'postTreatmentDatabaseRequest', postTreatmentDatabaseRequest)
            const localVarPath = `/api/treatment-databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTreatmentDatabaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTreatmentDatabase: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTreatmentDatabase', 'id', id)
            const localVarPath = `/api/treatment-databases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutTreatmentDatabaseRequest} putTreatmentDatabaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTreatmentDatabase: async (id: string, putTreatmentDatabaseRequest: PutTreatmentDatabaseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editTreatmentDatabase', 'id', id)
            // verify required parameter 'putTreatmentDatabaseRequest' is not null or undefined
            assertParamExists('editTreatmentDatabase', 'putTreatmentDatabaseRequest', putTreatmentDatabaseRequest)
            const localVarPath = `/api/treatment-databases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTreatmentDatabaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} packageId 
         * @param {string} techniqueId 
         * @param {number} treatmentTime 
         * @param {string} treatmentFormat 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase: async (productId: string, packageId: string, techniqueId: string, treatmentTime: number, treatmentFormat: string, locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase', 'productId', productId)
            // verify required parameter 'packageId' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase', 'packageId', packageId)
            // verify required parameter 'techniqueId' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase', 'techniqueId', techniqueId)
            // verify required parameter 'treatmentTime' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase', 'treatmentTime', treatmentTime)
            // verify required parameter 'treatmentFormat' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase', 'treatmentFormat', treatmentFormat)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase', 'locationId', locationId)
            const localVarPath = `/api/treatment-databases/get-by-product-package-technique-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (packageId !== undefined) {
                localVarQueryParameter['packageId'] = packageId;
            }

            if (techniqueId !== undefined) {
                localVarQueryParameter['techniqueId'] = techniqueId;
            }

            if (treatmentTime !== undefined) {
                localVarQueryParameter['treatmentTime'] = treatmentTime;
            }

            if (treatmentFormat !== undefined) {
                localVarQueryParameter['treatmentFormat'] = treatmentFormat;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} packageId 
         * @param {string} techniqueId 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFromProductAndPackageAndTechniqueInTreatmentDataBase: async (productId: string, packageId: string, techniqueId: string, locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueInTreatmentDataBase', 'productId', productId)
            // verify required parameter 'packageId' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueInTreatmentDataBase', 'packageId', packageId)
            // verify required parameter 'techniqueId' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueInTreatmentDataBase', 'techniqueId', techniqueId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getAllFromProductAndPackageAndTechniqueInTreatmentDataBase', 'locationId', locationId)
            const localVarPath = `/api/treatment-databases/get-by-product-package-technique`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (packageId !== undefined) {
                localVarQueryParameter['packageId'] = packageId;
            }

            if (techniqueId !== undefined) {
                localVarQueryParameter['techniqueId'] = techniqueId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageFromProductInTreatmentDataBase: async (id: string, locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPackageFromProductInTreatmentDataBase', 'id', id)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getPackageFromProductInTreatmentDataBase', 'locationId', locationId)
            const localVarPath = `/api/treatment-databases/product/{id}/location/{locationId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageInTreatmentDataBase: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/treatment-databases/packages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsInTreatmentDataBase: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getProductsInTreatmentDataBase', 'locationId', locationId)
            const localVarPath = `/api/treatment-databases/products/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} packageId 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnniqueFromProductAndPackageInTreatmentDataBase: async (productId: string, packageId: string, locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getTechnniqueFromProductAndPackageInTreatmentDataBase', 'productId', productId)
            // verify required parameter 'packageId' is not null or undefined
            assertParamExists('getTechnniqueFromProductAndPackageInTreatmentDataBase', 'packageId', packageId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getTechnniqueFromProductAndPackageInTreatmentDataBase', 'locationId', locationId)
            const localVarPath = `/api/treatment-databases/techniques`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (packageId !== undefined) {
                localVarQueryParameter['packageId'] = packageId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDatabaseById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTreatmentDatabaseById', 'id', id)
            const localVarPath = `/api/treatment-databases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDatatbases: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/treatment-databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchText] 
         * @param {string} [location] 
         * @param {string} [product] 
         * @param {string} [insects] 
         * @param {string} [_package] 
         * @param {string} [technique] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDatatbasesSearch: async (searchText?: string, location?: string, product?: string, insects?: string, _package?: string, technique?: string, limit?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/treatment-databases/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (insects !== undefined) {
                localVarQueryParameter['insects'] = insects;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (technique !== undefined) {
                localVarQueryParameter['technique'] = technique;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TreatmentDatabasesApi - functional programming interface
 * @export
 */
export const TreatmentDatabasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TreatmentDatabasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostTreatmentDatabaseRequest} postTreatmentDatabaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTreatmentDatabase(postTreatmentDatabaseRequest: PostTreatmentDatabaseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTreatmentDatabase(postTreatmentDatabaseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTreatmentDatabase(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTreatmentDatabase(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutTreatmentDatabaseRequest} putTreatmentDatabaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editTreatmentDatabase(id: string, putTreatmentDatabaseRequest: PutTreatmentDatabaseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutTreatmentDatabaseRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editTreatmentDatabase(id, putTreatmentDatabaseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} packageId 
         * @param {string} techniqueId 
         * @param {number} treatmentTime 
         * @param {string} treatmentFormat 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase(productId: string, packageId: string, techniqueId: string, treatmentTime: number, treatmentFormat: string, locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase(productId, packageId, techniqueId, treatmentTime, treatmentFormat, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} packageId 
         * @param {string} techniqueId 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFromProductAndPackageAndTechniqueInTreatmentDataBase(productId: string, packageId: string, techniqueId: string, locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFromProductAndPackageAndTechniqueInTreatmentDataBase(productId, packageId, techniqueId, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackageFromProductInTreatmentDataBase(id: string, locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackageFromProductInTreatmentDataBase(id, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackageInTreatmentDataBase(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackageInTreatmentDataBase(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsInTreatmentDataBase(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsInTreatmentDataBase(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} packageId 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnniqueFromProductAndPackageInTreatmentDataBase(productId: string, packageId: string, locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTechnniqueFromProductAndPackageInTreatmentDataBase(productId, packageId, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentDatabaseById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentDatabaseById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentDatatbases(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentDatatbases(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [searchText] 
         * @param {string} [location] 
         * @param {string} [product] 
         * @param {string} [insects] 
         * @param {string} [_package] 
         * @param {string} [technique] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentDatatbasesSearch(searchText?: string, location?: string, product?: string, insects?: string, _package?: string, technique?: string, limit?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentsdatabaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentDatatbasesSearch(searchText, location, product, insects, _package, technique, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TreatmentDatabasesApi - factory interface
 * @export
 */
export const TreatmentDatabasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TreatmentDatabasesApiFp(configuration)
    return {
        /**
         * 
         * @param {PostTreatmentDatabaseRequest} postTreatmentDatabaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTreatmentDatabase(postTreatmentDatabaseRequest: PostTreatmentDatabaseRequest, options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.addTreatmentDatabase(postTreatmentDatabaseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTreatmentDatabase(id: string, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.deleteTreatmentDatabase(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutTreatmentDatabaseRequest} putTreatmentDatabaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTreatmentDatabase(id: string, putTreatmentDatabaseRequest: PutTreatmentDatabaseRequest, options?: any): AxiosPromise<PutTreatmentDatabaseRequest> {
            return localVarFp.editTreatmentDatabase(id, putTreatmentDatabaseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} packageId 
         * @param {string} techniqueId 
         * @param {number} treatmentTime 
         * @param {string} treatmentFormat 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase(productId: string, packageId: string, techniqueId: string, treatmentTime: number, treatmentFormat: string, locationId: string, options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase(productId, packageId, techniqueId, treatmentTime, treatmentFormat, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} packageId 
         * @param {string} techniqueId 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFromProductAndPackageAndTechniqueInTreatmentDataBase(productId: string, packageId: string, techniqueId: string, locationId: string, options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.getAllFromProductAndPackageAndTechniqueInTreatmentDataBase(productId, packageId, techniqueId, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageFromProductInTreatmentDataBase(id: string, locationId: string, options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.getPackageFromProductInTreatmentDataBase(id, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageInTreatmentDataBase(options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.getPackageInTreatmentDataBase(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsInTreatmentDataBase(locationId: string, options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.getProductsInTreatmentDataBase(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} packageId 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnniqueFromProductAndPackageInTreatmentDataBase(productId: string, packageId: string, locationId: string, options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.getTechnniqueFromProductAndPackageInTreatmentDataBase(productId, packageId, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDatabaseById(id: string, options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.getTreatmentDatabaseById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDatatbases(options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.getTreatmentDatatbases(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchText] 
         * @param {string} [location] 
         * @param {string} [product] 
         * @param {string} [insects] 
         * @param {string} [_package] 
         * @param {string} [technique] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDatatbasesSearch(searchText?: string, location?: string, product?: string, insects?: string, _package?: string, technique?: string, limit?: number, page?: number, options?: any): AxiosPromise<GetTreatmentsdatabaseResponse> {
            return localVarFp.getTreatmentDatatbasesSearch(searchText, location, product, insects, _package, technique, limit, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addTreatmentDatabase operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiAddTreatmentDatabaseRequest
 */
export interface TreatmentDatabasesApiAddTreatmentDatabaseRequest {
    /**
     * 
     * @type {PostTreatmentDatabaseRequest}
     * @memberof TreatmentDatabasesApiAddTreatmentDatabase
     */
    readonly postTreatmentDatabaseRequest: PostTreatmentDatabaseRequest
}

/**
 * Request parameters for deleteTreatmentDatabase operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiDeleteTreatmentDatabaseRequest
 */
export interface TreatmentDatabasesApiDeleteTreatmentDatabaseRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiDeleteTreatmentDatabase
     */
    readonly id: string
}

/**
 * Request parameters for editTreatmentDatabase operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiEditTreatmentDatabaseRequest
 */
export interface TreatmentDatabasesApiEditTreatmentDatabaseRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiEditTreatmentDatabase
     */
    readonly id: string

    /**
     * 
     * @type {PutTreatmentDatabaseRequest}
     * @memberof TreatmentDatabasesApiEditTreatmentDatabase
     */
    readonly putTreatmentDatabaseRequest: PutTreatmentDatabaseRequest
}

/**
 * Request parameters for getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBaseRequest
 */
export interface TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBaseRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase
     */
    readonly productId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase
     */
    readonly packageId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase
     */
    readonly techniqueId: string

    /**
     * 
     * @type {number}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase
     */
    readonly treatmentTime: number

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase
     */
    readonly treatmentFormat: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase
     */
    readonly locationId: string
}

/**
 * Request parameters for getAllFromProductAndPackageAndTechniqueInTreatmentDataBase operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueInTreatmentDataBaseRequest
 */
export interface TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueInTreatmentDataBaseRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueInTreatmentDataBase
     */
    readonly productId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueInTreatmentDataBase
     */
    readonly packageId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueInTreatmentDataBase
     */
    readonly techniqueId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueInTreatmentDataBase
     */
    readonly locationId: string
}

/**
 * Request parameters for getPackageFromProductInTreatmentDataBase operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiGetPackageFromProductInTreatmentDataBaseRequest
 */
export interface TreatmentDatabasesApiGetPackageFromProductInTreatmentDataBaseRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetPackageFromProductInTreatmentDataBase
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetPackageFromProductInTreatmentDataBase
     */
    readonly locationId: string
}

/**
 * Request parameters for getProductsInTreatmentDataBase operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiGetProductsInTreatmentDataBaseRequest
 */
export interface TreatmentDatabasesApiGetProductsInTreatmentDataBaseRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetProductsInTreatmentDataBase
     */
    readonly locationId: string
}

/**
 * Request parameters for getTechnniqueFromProductAndPackageInTreatmentDataBase operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiGetTechnniqueFromProductAndPackageInTreatmentDataBaseRequest
 */
export interface TreatmentDatabasesApiGetTechnniqueFromProductAndPackageInTreatmentDataBaseRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTechnniqueFromProductAndPackageInTreatmentDataBase
     */
    readonly productId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTechnniqueFromProductAndPackageInTreatmentDataBase
     */
    readonly packageId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTechnniqueFromProductAndPackageInTreatmentDataBase
     */
    readonly locationId: string
}

/**
 * Request parameters for getTreatmentDatabaseById operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiGetTreatmentDatabaseByIdRequest
 */
export interface TreatmentDatabasesApiGetTreatmentDatabaseByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTreatmentDatabaseById
     */
    readonly id: string
}

/**
 * Request parameters for getTreatmentDatatbasesSearch operation in TreatmentDatabasesApi.
 * @export
 * @interface TreatmentDatabasesApiGetTreatmentDatatbasesSearchRequest
 */
export interface TreatmentDatabasesApiGetTreatmentDatatbasesSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTreatmentDatatbasesSearch
     */
    readonly searchText?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTreatmentDatatbasesSearch
     */
    readonly location?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTreatmentDatatbasesSearch
     */
    readonly product?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTreatmentDatatbasesSearch
     */
    readonly insects?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTreatmentDatatbasesSearch
     */
    readonly _package?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentDatabasesApiGetTreatmentDatatbasesSearch
     */
    readonly technique?: string

    /**
     * 
     * @type {number}
     * @memberof TreatmentDatabasesApiGetTreatmentDatatbasesSearch
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof TreatmentDatabasesApiGetTreatmentDatatbasesSearch
     */
    readonly page?: number
}

/**
 * TreatmentDatabasesApi - object-oriented interface
 * @export
 * @class TreatmentDatabasesApi
 * @extends {BaseAPI}
 */
export class TreatmentDatabasesApi extends BaseAPI {
    /**
     * 
     * @param {TreatmentDatabasesApiAddTreatmentDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public addTreatmentDatabase(requestParameters: TreatmentDatabasesApiAddTreatmentDatabaseRequest, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).addTreatmentDatabase(requestParameters.postTreatmentDatabaseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentDatabasesApiDeleteTreatmentDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public deleteTreatmentDatabase(requestParameters: TreatmentDatabasesApiDeleteTreatmentDatabaseRequest, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).deleteTreatmentDatabase(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentDatabasesApiEditTreatmentDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public editTreatmentDatabase(requestParameters: TreatmentDatabasesApiEditTreatmentDatabaseRequest, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).editTreatmentDatabase(requestParameters.id, requestParameters.putTreatmentDatabaseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase(requestParameters: TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBaseRequest, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase(requestParameters.productId, requestParameters.packageId, requestParameters.techniqueId, requestParameters.treatmentTime, requestParameters.treatmentFormat, requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueInTreatmentDataBaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public getAllFromProductAndPackageAndTechniqueInTreatmentDataBase(requestParameters: TreatmentDatabasesApiGetAllFromProductAndPackageAndTechniqueInTreatmentDataBaseRequest, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).getAllFromProductAndPackageAndTechniqueInTreatmentDataBase(requestParameters.productId, requestParameters.packageId, requestParameters.techniqueId, requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentDatabasesApiGetPackageFromProductInTreatmentDataBaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public getPackageFromProductInTreatmentDataBase(requestParameters: TreatmentDatabasesApiGetPackageFromProductInTreatmentDataBaseRequest, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).getPackageFromProductInTreatmentDataBase(requestParameters.id, requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public getPackageInTreatmentDataBase(options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).getPackageInTreatmentDataBase(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentDatabasesApiGetProductsInTreatmentDataBaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public getProductsInTreatmentDataBase(requestParameters: TreatmentDatabasesApiGetProductsInTreatmentDataBaseRequest, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).getProductsInTreatmentDataBase(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentDatabasesApiGetTechnniqueFromProductAndPackageInTreatmentDataBaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public getTechnniqueFromProductAndPackageInTreatmentDataBase(requestParameters: TreatmentDatabasesApiGetTechnniqueFromProductAndPackageInTreatmentDataBaseRequest, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).getTechnniqueFromProductAndPackageInTreatmentDataBase(requestParameters.productId, requestParameters.packageId, requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentDatabasesApiGetTreatmentDatabaseByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public getTreatmentDatabaseById(requestParameters: TreatmentDatabasesApiGetTreatmentDatabaseByIdRequest, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).getTreatmentDatabaseById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public getTreatmentDatatbases(options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).getTreatmentDatatbases(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentDatabasesApiGetTreatmentDatatbasesSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentDatabasesApi
     */
    public getTreatmentDatatbasesSearch(requestParameters: TreatmentDatabasesApiGetTreatmentDatatbasesSearchRequest = {}, options?: AxiosRequestConfig) {
        return TreatmentDatabasesApiFp(this.configuration).getTreatmentDatatbasesSearch(requestParameters.searchText, requestParameters.location, requestParameters.product, requestParameters.insects, requestParameters._package, requestParameters.technique, requestParameters.limit, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}
